import type { PlayerNotesComponentSpec, PlayerNotesBuilderMisc } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { calendarWidgetDatePatch, isBound } from "./_shared";

// player_notes has no drills/tab — apply only the athlete selection.
export const playerNotesControlPanel: ControlPanelHandler<PlayerNotesComponentSpec> = (spec, patch) => {
  spec.player_notes_builder_misc = {
    ...(spec.player_notes_builder_misc as PlayerNotesBuilderMisc),
    ...(patch.applyDate && !isBound(spec.player_notes_builder_misc, "date", patch) && calendarWidgetDatePatch(patch.date)),
    ...(patch.applySubjects && !isBound(spec.player_notes_builder_misc, "subject", patch) && {
      selectedSubjects: patch.subjects.selectedSubjects,
    }),
  };
};
